import type { MlsListingCandidate } from "../types/mlsCandidate";

// MB-1520: the api flagged this row as another record of a property already
// held or selected. The checkbox stays enabled - ticking it is the agent's
// override, and the api then markets that record on its own.
export const duplicateHint = (
    candidate: Pick<MlsListingCandidate, "duplicateOf">,
): string | null =>
    candidate.duplicateOf
        ? `Same property as MLS# ${candidate.duplicateOf} - already in your account or selected above. Tick it only to market it separately.`
        : null;
